/**
 * Remove null, undefined, and empty-string values from a query params
 * object, guarding against prototype-polluting keys like `__proto__`.
 *
 * @param {Object} params
 * @returns {Object}
 */
export function cleanParams(params = {}) {
    return Object.fromEntries(
        Object.entries(params).filter(
            ([key, value]) =>
                value !== null &&
                value !== undefined &&
                value !== '' &&
                key !== '__proto__'
        )
    )
}
